import type { QuizResponse, QuizQuestionSet } from "../quiz.types";

/**
 * Normalizes quiz response data from the API by grouping questions into question sets.
 * Questions are grouped by their header field.
 */
export function normalizeQuizResponseData(data: {
  questions: Array<{ header: string; additional_info: string; [key: string]: unknown }>;
  [key: string]: unknown;
}): QuizResponse {
  const dataWithQuestionSets = {
    ...data,
    questionSets: data.questions.reduce(
      (acc: QuizQuestionSet[], question) => {
        const header = question.header;
        const subheader = question.additional_info;

        const existingSet = acc.find((set) => set.header === header);

        if (existingSet) {
          existingSet.questions.push(question as QuizResponse["questions"][number]);
        } else {
          acc.push({
            header,
            description: subheader,
            questions: [question as QuizResponse["questions"][number]],
          });
        }

        return acc;
      },
      []
    ),
  };

  return dataWithQuestionSets as QuizResponse;
}

